define('comment-tool',['require','config','helpers'],function (require) {
    'use strict';

    var config = require('config'),
        helpers = require('helpers'),
        ctWindow=null,
        contentEntityId=null;

    function init($, trainingVM) {
        setTimeout(function() {
            if (!config.commentTool || !config.commentTool.enabled) {
                $('.header-commenttool-cont').hide(0);
                $('.footer-commenttool-cont').hide(0);
            }
        }, 200);
    }

    function changed($, trainingVM) {
        contentEntityId = trainingVM.contentEntityId();
        if (ctWindow != null)
        {
            try {
                ctWindow.location = getCommentsUrl();
            } catch (ex) { }
        }
    }

    function open() {
        if (helpers.URL.getParam('tokenId') === '') {
            return 'noToken';
        }else{
			console.log(ctWindow);
			if (!isWindowOpen()) {
				ctWindow = window.open(getCommentsUrl(), "ctWindow", "width=800, height=450, scrollbars=yes");
			}
			ctWindow.focus();
        }
        if (ctWindow.closed) {
            return 'blocked';
        }
        return 'ok';
    }
	function isWindowOpen(){
		if(ctWindow == null){
			return false;
		}else{
			if(ctWindow.closed){
				return false;
			}
		}
		return true;
	}
    function getCommentsUrl() {
        return config.commentTool.url + "/?id=" + contentEntityId + "&authorizationToken=" + helpers.URL.getParam('tokenId');
    }

    return {
        init: init,
        changed: changed,
        open: open
    };
});

